import { dispositifSousDispositifMap, type DispositifOuCombine } from './DispositifSousDispositif'
import type { Dispositif } from './Dispositif'

/** Map dispositif -> toutes les combinaisons possibles (ex: AF -> [AF!BC, AF!VAE, ...]) */
const combinaisonsParDispositif = new Map<Dispositif, string[]>(
  (Object.entries(dispositifSousDispositifMap) as [Dispositif, readonly string[]][]).map(
    ([dispositif, sousDispositifs]) => [
      dispositif,
      sousDispositifs.length > 0
        ? sousDispositifs.map((sd) => `${dispositif}!${sd}`)
        : [dispositif], // CAPP, DR sans sous-dispositifs
    ],
  ),
)

/**
 * Expand: 'AF' -> ['AF!BC', 'AF!VAE', ...], 'FPE!CDPI' -> ['FPE!CDPI']
 * Pour afficher dans le dropdown les items sélectionnés.
 */
export function expandDispositifs(dispositifs: string[]): string[] {
  const result: string[] = []
  for (const id of dispositifs ?? []) {
    if (id.includes('!')) {
      result.push(id)
    } else {
      const combinaisons = combinaisonsParDispositif.get(id as Dispositif)
      if (combinaisons) result.push(...combinaisons)
      else result.push(id)
    }
  }
  return result
}

/**
 * Collapse: ['AF!BC', 'AF!VAE', ...] -> ['AF'] si tous sélectionnés
 * Pour envoyer au backend un format optimisé.
 */
export function collapseDispositifs(selection: string[]): DispositifOuCombine[] {
  // Grouper par dispositif
  const parDispositif = new Map<string, string[]>()
  for (const id of selection) {
    const dispositif = id.split('!')[0]!
    if (!parDispositif.has(dispositif)) parDispositif.set(dispositif, [])
    parDispositif.get(dispositif)!.push(id)
  }

  const result: DispositifOuCombine[] = []
  for (const [dispositif, selectedIds] of parDispositif) {
    const allIds = combinaisonsParDispositif.get(dispositif as Dispositif) ?? []
    if (selectedIds.length === allIds.length && allIds.length > 0) {
      result.push(dispositif as DispositifOuCombine)
    } else {
      result.push(...(selectedIds as DispositifOuCombine[]))
    }
  }
  return result
}
